// Simple client-side topic registry using localStorage

const STORAGE_KEY = 'customTopics:v1';

export function slugify(title) {
  return (title || '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

export function getTopics() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (_) {
    return [];
  }
}

export function saveTopic(topic) {
  const topics = getTopics();
  const idx = topics.findIndex((t) => t.slug === topic.slug);
  if (idx >= 0) topics[idx] = topic; else topics.push(topic);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(topics));
    // notify listeners
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('topics-updated'));
    }
  } catch (_) {
    // ignore storage errors
  }
}

export function getTopicBySlug(slug) {
  return getTopics().find((t) => t.slug === slug) || null;
}


